module.exports = __webpack_public_path__ + "img/a012_2.958e32ed.jpeg";